// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a specific note.
 *
 * @param noteKey - The key of the note to fetch audit events for
 * @returns A list of audit events for the note
 */
export async function getNoteAuditEvents(noteKey: string) {
  const url = `/v1/note/${noteKey}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'NoteAuditEvents',
    endpoint: url,
  });
}
